import { KYMW1104Model } from './../kymw1104.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 会員生協取得クラス
 *
 * @export InitItemCodeComboService
 * @class InitItemCodeComboService
 * @extends {PlessResponder}
 */
@Injectable()
export class InitItemCodeComboService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW1104Model;
  private pCode: string;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof InitItemCodeComboService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        PCode: this.pCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof InitItemCodeComboService
   */
  execute(model: KYMW1104Model, pCode: string, successFunc: Function = null): void {
    this.model = model;
    this.pCode = pCode;
    this.successFunc = successFunc;
    this.send('initItemCodeCombo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof InitItemCodeComboService
   */
  success(data: any): void {
    this.model.updateInitItemCodeComboList(data);

    // 会員生協の選定アイテム取得
    const pCode = this.model.pCode;
    this.model.kymw1104Component.getSelectedCodesForCoopsService.execute(this.model, pCode);

    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
